<template>
  <vs-tabs position="top" class="tabs-shadow-none" id="input-section-tabs">
    <vs-tab label="หน้าหลัก">
      <MainForm :form="form" @calculate="$emit('calculate', $event)"/>
    </vs-tab>
    <vs-tab label="รายละเอียดค่าดำเนินคดี">
      <ProsecutionFeeForm :prosecutionFee="form.prosecutionFee"/>
    </vs-tab>
    <vs-tab label="รายละเอียดการคิดดอกเบี้ย">
      <RestructuringInterestForm :restructuring-interest="form.restructuringInterest"/>
    </vs-tab>
    <vs-tab label="รายละเอียดการชำระเงิน">
      <PaymentForm :payments="form.payments" :onAddPayment="onAddPayment" :onRemovePayment="onRemovePayment" :onClearPayments="onClearPayments"/>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import 'flatpickr/dist/themes/dark.css'
import MainForm
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationRestructuringCard/components/InputSection/MainForm.vue";
import ProsecutionFeeForm
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationRestructuringCard/components/InputSection/ProsecutionFeeForm.vue";
import RestructuringInterestForm
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationRestructuringCard/components/InputSection/RestructuringInterestForm.vue";
import PaymentForm
  from "@/views/pages/HeaderMenu/InstallmentCalculation/Components/InstallmentCalculationRestructuringCard/components/InputSection/PaymentForm.vue";

/**
 * @typedef {Object} LoanForm
 * @property {Object} prosecutionFee
 * @property {number} restructuringFee
 * @property {number} restructuringPenalty
 * @property {Object} restructuringInterest
 * @property {number} principle
 * @property {number} installmentCount
 * @property {number} interestRate
 * @property {string} paymentDue
 * @property {Object} configPaymentDue
 */

export default {
  name: 'LoanInputSection',
  components: {MainForm, ProsecutionFeeForm, RestructuringInterestForm, PaymentForm},
  props: {
    /** @type {LoanForm} */
    form: {type: Object, required: true},
    onAddPayment: {type: Function, required: true},
    onRemovePayment: {type: Function, required: true},
    onClearPayments: {type: Function, required: true}
  },
}
</script>
